import {Redirect, Route, Switch} from 'react-router-dom';
import STLBScene from './STLBScene';
import Urls from '../../constants/urls';
import { 
    view10Hotspots,
    view11Hotspots,
    view12Hotspots,
    view13Hotspots,
    view14Hotspots,
    view1Hotspots,
    view3Hotspots,
    view4Hotspots,
    view5Hotspots,
    view6Hotspots,
    view7Hotspots,
    view8Hotspots
} from './data';

const STLBRooms = () => {
    return (
      <Switch>
        <Route 
          {...Urls.stlBlues.root}
          render={() => <Redirect to={Urls.stlBlues.view3.path} />}  
        />
        <Route {...Urls.stlBlues.view1}>
            <STLBScene
                id="stl-blues-view1"
                yRotation={270}
                hotspots={view1Hotspots}
            />
        </Route>
        <Route {...Urls.stlBlues.view3}>
            <STLBScene
                id="stl-blues-view3"
                yRotation={270}
                hotspots={view3Hotspots}
            />
        </Route>
        <Route {...Urls.stlBlues.view4}>
            <STLBScene
                id="stl-blues-view4"
                yRotation={270}
                hotspots={view4Hotspots}
            />
        </Route>
        <Route {...Urls.stlBlues.view5}>
            <STLBScene
                id="stl-blues-view5"
                yRotation={270}
                hotspots={view5Hotspots}
            />
        </Route>
        <Route {...Urls.stlBlues.view6}>
            <STLBScene
                id="stl-blues-view6"
                yRotation={270}
                hotspots={view6Hotspots}
            />
        </Route>
        <Route {...Urls.stlBlues.view7}>
            <STLBScene
                id="stl-blues-view7"
                yRotation={270}
                hotspots={view7Hotspots}
            />
        </Route>
        <Route {...Urls.stlBlues.view8}>
            <STLBScene
                id="stl-blues-view8"
                yRotation={270}
                hotspots={view8Hotspots}
            />
        </Route>
        <Route {...Urls.stlBlues.view10}>
            <STLBScene
                id="stl-blues-view10"
                yRotation={270}
                hotspots={view10Hotspots}
            />
        </Route>
        <Route {...Urls.stlBlues.view11}>
            <STLBScene
                id="stl-blues-view11"
                yRotation={270}
                hotspots={view11Hotspots}
            />
        </Route>
        <Route {...Urls.stlBlues.view12}>
            <STLBScene
                id="stl-blues-view12"
                yRotation={270}
                hotspots={view12Hotspots}
            />
        </Route>
        <Route {...Urls.stlBlues.view13}>
            <STLBScene
                id="stl-blues-view13"
                yRotation={270}
                hotspots={view13Hotspots}
            />
        </Route>
        <Route {...Urls.stlBlues.view14}>
            <STLBScene
                id="stl-blues-view14"
                yRotation={270}
                hotspots={view14Hotspots}
            />
        </Route>
      </Switch>
    );
  };
  
  export default STLBRooms;
